import React, { useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import axios from "axios";
import "../../assets/style/DeleteModal.css"; // Import the custom CSS

export default function DeleteConfirmationModal({
  open,
  handleClose,
  request_url,
  getApi,
  itemName = "item",
}) {
  const [isDeleting, setIsDeleting] = useState(false);

  if (!open) return null;

  const handleDelete = async () => {
    try {
      setIsDeleting(true);
      const token = localStorage.getItem("token");
      const response = await axios.delete(
        "http://103.251.215.17:8090" + request_url,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      handleClose();
      getApi();
      toast.success(response.data.message);
    } catch (error) {
      toast.error(error.response?.data?.message || "Error deleting item");
    } finally {
      setIsDeleting(false);
      handleClose();
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target.classList.contains("usa-modal-overlay")) {
      handleClose();
    }
  };

  return (
    <div
      className="usa-modal-overlay"
      onClick={handleBackdropClick}
      aria-labelledby="modal-heading"
    >
      <div className="usa-modal-wrapper">
        <div className="usa-modal usa-modal-danger" role="dialog">
          <div className="usa-modal-header">
            <h2 className="usa-modal-heading" id="modal-heading">
              Delete {itemName}
            </h2>
            <button
              className="usa-modal-close"
              aria-label="Close this modal"
              onClick={handleClose}
            >
              <span className="usa-sr-only">Close</span>
              <div className="usa-modal-close-icon"></div>
            </button>
          </div>

          <div className="usa-modal-content">
            <div className="usa-alert usa-alert-warning">
              <div className="usa-alert-body">
                <p>Are you sure you want to delete this row?</p>
              </div>
            </div>
          </div>

          <div className="usa-modal-footer">
            <button
              className="usa-button usa-button-outline"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              className="usa-button usa-button-danger"
              onClick={handleDelete}
              disabled={isDeleting}
            >
              {isDeleting ? (
                <>
                  <span className="usa-spinner usa-spinner-small"></span>
                  <span>Processing...</span>
                </>
              ) : (
                "Yes, Delete"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
